import BuildMagnitude from './BuildMagnitude';
import BuildMmi from './BuildMmi';
import BuildCdi from './BuildCdi';
import BuildSm from './BuildSm';
import BuidDepthText from './BuildDepthText';
import { formatMomentFromNow } from 'utils/date.utils';

export const NotificationCard = props => {
	const buildBeachBall = beachBall => {
		if (beachBall != null) {
			return (
			<div className = "dates-tm">
				<img className = "dates-icons" src={beachBall} alt="mf"></img>
			</div>
			);
		} else {
			return "";
		}
	};
    return(
		<a 
			href = { `/detallesismo/${props.notification.id}/resumen` }
			target = " _blank"
			rel = " noopener noreferrer"
			style = {{ textDecoration: "none", color: "white" }}
		>
			<div className = "notification-card" >
				<div className = "notification-item">
					<div className = "header-notification">
						<p>Sismo destacado</p>
						<p>{props.notification.properties.place}</p>
						
					</div>
					<div className = "info-notification"> 
						<div className = "intensity-notification">
							<div className = "magnitude-container">
								<BuildMagnitude
									mag = { props.notification.properties.mag }
									felt = { props.notification.properties.felt }
								/>
							</div>
						</div> 
						<div className = "main">
							<BuidDepthText
								status = { props.notification.properties.status }
								depth = { props.notification.geometry.coordinates[ 2 ] }
							/>
							<div className = "status-icons-notification">
								<p className = "container-status">Estado: {props.notification.properties.status === "manual" ? "Manual" : "Automatico"}</p>
								<div className = "container-icons">
									<div className = "dates-mmi">
										<BuildMmi mmi={props.notification.properties.mmi} />
									</div>
									<div className = "dates-cdi">
										<BuildCdi cdi={props.notification.properties.cdi} />
									</div>
									<div className = "dates-sm">
										<BuildSm sm={props.notification.properties.sm} /> 
									</div>
									{buildBeachBall()}
								</div>
							</div>
							<hr></hr>
							{ props.notification.properties.localTime } Hora local, { formatMomentFromNow( props.notification.properties.localTime ) }
						</div> 
					</div> 
				</div>
			</div>	
		</a>
		
    ) 
}